import { ListingDetailsType } from '~addListing/types';

const fields = ['title', 'description', 'address'] as const;
type LocalizedListingField = (typeof fields)[number];
type LocalizedListingKey = `${LocalizedListingField}-${'ar' | 'en'}`;

export const getLocalizedListingPrefill = ({
  translations = [],
}: {
  translations?: ListingDetailsType['translations'];
}): Record<LocalizedListingKey, string> => {
  const byLocale = {
    ar: translations.find((t) => t.locale === 'ar'),
    en: translations.find((t) => t.locale === 'en'),
  } as const;

  return (['ar', 'en'] as const).reduce(
    (acc, locale) => {
      fields.forEach((field) => {
        acc[`${field}-${locale}`] = byLocale[locale]?.[field] || '';
      });
      return acc;
    },
    {} as Record<LocalizedListingKey, string>,
  );
};
